import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const TeamEditModal = ({ show, handleClose }) => {
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Edit Team</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form >
                        <Form.Group className="mb-3">
                            <Form.Label>Team Name:</Form.Label>
                            <Form.Control type="text" placeholder="Enter Team Name " />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>League:</Form.Label>
                            <Form.Select aria-label="Select alert type">
                                <option value="league-1">League 1</option>
                                <option value="league-2">League 2</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Account Manager:</Form.Label>
                            <Form.Select aria-label="Select alert type">
                                <option value="Account Manager-1">Account Manager 1</option>
                                <option value="Account Manager-2">Account Manager 2</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Logo:</Form.Label>
                            <Form.Control type="file" placeholder="Logo" />
                        </Form.Group>
                       

                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TeamEditModal;